import type { State } from '../types.tsx';

export const isViewsLoading = (state: State): boolean => state.meta.loading;

export const getDeliveryDataFetchError = (state: State): Error | undefined =>
	state.meta.deliveryDataFetchError;
